import { Link, useLocation, useNavigate } from "react-router-dom";
import { svgLinks } from "../../../public/assets/assetLinks";

import { Button } from "@/components/ui";
import { RouteConstant } from "@/util/constant/RouteConstant";

type AuthLayoutProps = {
  children: React.ReactNode;
  title: string;
  subtitle?: string;
  mainContainerProps?: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLElement>,
    HTMLElement
  >;
} & React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
>;

const AuthLayout = ({ children, title, subtitle }: AuthLayoutProps) => {
  const location = useLocation();
  const navigate = useNavigate();
  const pathname = location.pathname;

  const renderFooterText = (pathname: string) => {
    switch (pathname) {
      case "/login":
        return (
          <p className="text-center text-sm text-white">
            Not registered yet?{" "}
            <Link to="/signup" className="text-red-700">
              Sign up
            </Link>
          </p>
        );
      case "/signup":
        return (
          <p className="text-center text-sm">
            Already have an account?{" "}
            <Link to="/login" className="text-red-700">
              Sign in
            </Link>
          </p>
        );
      case "/reset-password":
        return (
          <p className="text-center text-sm">
            Didn't get a code?{" "}
            <Link to="/signin" className="text-red-700">
              Resend OTP
            </Link>
          </p>
        );
    }
  };

  return (
    <div className={"flex-col min-h-screen justify-between flex w-full h-full"}>
    <div className="md:flex cursor-pointer justify-between items-center mx-10 lg:my-5">
  <img
    src={svgLinks.logo3}
    className="size-28"
    alt={"logo"}
    onClick={() => navigate("/home")} 
  />

  <div>
    <div className="hidden md:flex-row md:flex md:items-center">
      {location.pathname === "/login" ? (
        <div className="gap-2 flex items-center">
          <h1 className="cursor-pointer hover:text-white">
            {"Don't have an account?"}
          </h1>
          <Button
            label="Sign up"
            state="secondary"
            onClick={() => navigate(RouteConstant.auth.signup.path)}
          />
        </div>
      ) : (
        <div className="gap-2 flex items-center">
          <h1 className="cursor-pointer hover:text-white">
            {"Already have an account?"}
          </h1>
          <Button
            label="Sign in"
            state="secondary"
            onClick={() => navigate(RouteConstant.auth.login.path)}
          />
        </div>
      )}
    </div>
  </div>
</div>

      <div className="items-center  flex flex-col justify-center ">
        <div className="flex-1 flex w-full justify-center items-center">
          <div className="bg-[#FFFFFF0D] shadow-sm  shadow-[#970E0E40]  max-w-md mx-5 rounded-xl py-5 lg:px-5 px-3 w-full ">
            <div className="justify-center items-center flex-col mt-5 flex space-y-3">
              <p className="font-bold lg:text-3xl text-xl">{title}</p>
              <p className="font-light lg:text-base text-center text-sm pb-3 ">
                {subtitle}
              </p>
            </div>
            <div>{children}</div>
            <div className={"block md:hidden"}>
              {renderFooterText(pathname)}
            </div>
          </div>
        </div>
      </div>
      <div className="flex py-3 items-center justify-center">
        <h1 className=" text-[#FFFFFF75]">
          Qoonity. All rights reserved. © {new Date().getFullYear()}
        </h1>
      </div>
    </div>
  );
};

export default AuthLayout;
